





































import Vue, { PropOptions } from 'vue';
import { cloneDeep } from 'lodash';
import { VueEditor } from 'vue2-editor';
interface ProductSalesPageFAQItemProps {
  faq: PropOptions;
}
interface ProductSalesPageFAQItemState {
  faqL: CreateUpdateSalesPageFAQRequest | null;
  expanded: boolean;
}

export default Vue.extend({
  name: 'ProductSalesPageFAQItem',
  components: { VueEditor },
  props: {
    faq: {
      type: Object as () => ProductSalesPageFAQResponse,
    },
  } as ProductSalesPageFAQItemProps,
  data(): ProductSalesPageFAQItemState {
    return {
      faqL: null,
      expanded: false,
    };
  },
  mounted() {
    this.expanded = !this.faq.question && !this.faq.answer;
  },
  computed: {
    title(): string {
      if (this.faqL) {
        if (this.faqL.id && !this.faqL.question) {
          return `${this.$t('PRODUCTS.LABELS.QUESTION')}`;
        } else {
          return (
            this.faqL.question ??
            (this.$t('PRODUCTS.LABELS.QUESTION') as string)
          );
        }
      }
      return this.$t('PRODUCTS.LABELS.QUESTION') as string;
    },
  },
  watch: {
    faq: {
      handler(value: ProductSalesPageFAQResponse) {
        this.faqL = cloneDeep(this.faq);
      },
      immediate: true,
    },
  },
  methods: {
    submit(): void {
      this.expanded = false;
      this.$emit('submit', this.faqL);
    },
    remove(): void {
      this.$emit('remove', this.faqL);
    },
    toggleExpand(): void {
      this.expanded = !this.expanded;
      this.faqL = cloneDeep(this.faq);
    },
  },
});
